<template>
  <span>
    <my-navbar></my-navbar>    
    <banner></banner>
    <div class="container"> 
      <clientes></clientes>
      <contacto></contacto>
      <whatsapp></whatsapp> 
    </div>
    <my-footer></my-footer>
  </span>
</template>

<script>
window.fbq('trackCustom', 'Clients');
import Whatsapp from '@/sections/Whatsapp.vue';
import Clientes from '@/sections/Clientes.vue';
import Banner from '@/sections/Banner.vue';
import MyNavbar from '@/sections/Navbar.vue';
import MyFooter from '@/sections/Footer.vue';
import Contacto from '@/sections/Contactanos.vue';

export default {
  name: 'app',
  data () {
    return {

    }
  },
  components: {    
    Clientes,
    Whatsapp,
    Banner,
    MyNavbar,
    Contacto,
    MyFooter
  }
}
</script>

<style>
  .container{
    width: 90%;
    margin: auto;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Clientes.vue